import NYTimesReviews from "./NYTimesReviews";
export default NYTimesReviews